<template>
  <div class="base-section">
    <slot></slot>
  </div>
</template>